module.exports = __webpack_public_path__ + "teqbahn-assets/media/11.b09ad582.jpg";